import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'MegaPack Terapia Resuelta — Construye Progreso™';
const preconnect = document.createElement('link');
preconnect.rel = 'preconnect';
preconnect.href = 'https://cdn.magicpatterns.com';
preconnect.crossOrigin = 'anonymous';
document.head.appendChild(preconnect);
const preloadImg = document.createElement('link');
preloadImg.rel = 'preload';
preloadImg.as = 'image';
preloadImg.type = 'image/webp';
(preloadImg as any).fetchPriority = 'high';
preloadImg.href = 'https://cdn.magicpatterns.com/uploads/cFzNNdWPCtUXaqVAzPY6jL/hf_20260421_185515_208515f9-39ff-4336-87a5-56bb3da67672-Photoroom.webp';
document.head.appendChild(preloadImg);
render(<App data-id="element-389" />, document.getElementById('root'));